import { render, staticRenderFns } from "./view-left.vue?vue&type=template&id=3bc30be8&scoped=true"
import script from "./view-left.vue?vue&type=script&lang=js"
export * from "./view-left.vue?vue&type=script&lang=js"
import style0 from "./view-left.vue?vue&type=style&index=0&id=3bc30be8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc30be8",
  null
  
)

export default component.exports